import { gql } from '@apollo/client';

export const pageUnassignedAssets = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageUnassignedAssets(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        AssetID
        BarCode
        SerialNumber
        Description
        Department
        Owner
        Location
        Description2
        Description3
        AssetNumber
        Acquired
        Year
      }
    }
  }
`;

export const UPDATE_UNASSIGNED_ASSETS = gql`
  mutation updateUnassignedAssets($owner: String!, $department: Int!, $year: String!, $source: String!) {
    updateUnassignedAssets(owner: $owner, department: $department, year: $year, source: $source) {
      updatedAssets {
        description1
        barCode
      }
      addedOwner {
        PhysicalOwner
      }
    }
  }
`;

export const UNASSIGNED_OWNERS = gql`
  query ($source: String!, $year: String!) {
    unassignedOwners(source: $source, year: $year) {
      Owner
    }
  }
`;

export const DEPARTMENTS_WITH_ABBR = gql`
  {
    readAllDepartments: readDepartments {
      id
      Abbreviation
      Name
    }
  }
`;

export const COMBINED_QUERY = gql`
  query ($source: String!, $year: String!) {
    unassignedOwners(source: $source, year: $year) {
      Owner
    }

    readAllDepartments: readDepartments {
      id
      Abbreviation
      Name
    }
  }
`;

export const GET_INVENTORY_YEAR = gql`
  query ($setting: String!) {
    getSettingByName(setting: $setting) {
      settingValue
    }
  }
`;
